import { render, staticRenderFns } from "./AgesInfo.vue?vue&type=template&id=44d3f6d2"
import script from "./AgesInfo.vue?vue&type=script&lang=js"
export * from "./AgesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports